export const reducer = (state, action) => {
	switch (action.type) {
		case 'setLoading':
			return {
				...state,
				loading: action.payload,
			};
		case 'setSeries':
			return {
				...state,
				series: action.payload,
			};
		case 'setCurrentPage':
			return {
				...state,
				currentPage: action.payload,
			};
	}
};
